// Anti-dilution adjustments — PSD §3.1, F1.5. Engine layer (framework-free).
/**
 * Adjust a preferred conversion ratio for an anti-dilution provision after a down round.
 * - fullRatchet: reset conversion ratio so effective price = lowest (down-round) price.
 * - weightedAverage (broad-based): standard formula adjusting ratio.
 */
export function adjustConversionRatio(inst, round, kind = 'broadWeightedAverage') {
    const baseRatio = inst.conversionRatio && inst.conversionRatio > 0 ? inst.conversionRatio : 1;
    const { oldPrice, newPrice, newShares, oldShares } = round;
    if (newPrice <= 0 || oldPrice <= 0)
        return baseRatio;
    switch (kind) {
        case 'fullRatchet': {
            // Conversion price resets to the lowest (new) price; ratio = oldPrice/newPrice
            return baseRatio * (oldPrice / newPrice);
        }
        case 'broadWeightedAverage':
        case 'narrowWeightedAverage': {
            // Broad: C = (A + B)/(A' + B) where A = oldShares*oldPrice, B = newShares*newPrice, A' = oldShares
            // Narrow uses total fully-diluted (approximated here as oldShares for simplicity).
            const A = oldShares * oldPrice;
            const B = newShares * newPrice;
            const totalShares = kind === 'broadWeightedAverage' ? oldShares + newShares : oldShares;
            const newConversionPrice = (A + B) / Math.max(1, totalShares);
            const effectivePrice = Math.min(oldPrice, newConversionPrice);
            return baseRatio * (oldPrice / effectivePrice);
        }
        default:
            return baseRatio;
    }
}
//# sourceMappingURL=antiDilution.js.map